// A page address from the browser bar. A mistyped or damaged escape ("%E0%A4") cannot be decoded; it
// must reach the "page not found" message, not throw while the screen is drawing.
export function decodeSlugPath(text) {
  try {
    return decodeURIComponent(text);
  } catch {
    return text;
  }
}
